<template>
	<PhysicalPosContainer class="mini-pos-physical" no-hide-mobile />
</template>

<script>
import PhysicalPosContainer from "@/console-pos/components/PhysicalPosContainer.vue";

export default {
	name: "MiniPos",
	components: {PhysicalPosContainer}
}
</script>

<style lang="scss">
@font-face {
	font-family: calculatorFont;
	src: url("https://old.img.qromo.io/fonts/digital-7-mono.ttf");
}
</style>
<style lang="scss" scoped>
.mini-pos-physical {
	margin: 20px;

	@media (max-width: 400px) {
		margin: 12px;
	}

}
</style>